import React, {useContext, useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom'; 
import { FormContext } from '../../Pages/Apply'

const Success = (props) => {

  const { activeStepIndex, setActiveStepIndex, formData, setFormData } = useContext(FormContext);
  const navigate = useNavigate();


    const goToApplications = () => {
        navigate('/registration/students');
    }

    const goToDashboard = () => {
        navigate('/registration/dashboard');
    }

    const startNewApplication = () => {
      setFormData({});
      setActiveStepIndex(0);
    }

return (
    <div className="content">
    
        <div className="">

        <div style = {{textAlign: 'center', marginTop: '25px', marginBottom: '25px'}} >
                <span style= {{fontSize: '27px', lineHeight: '41px', fontWeight: '600', letterSpacing: '0.11px', color: '#171725'}} > Applicaion Submitted Successfully.. </span>
        </div>


            <div style= {{marginTop: '50px', textAlign: 'center'}} > 
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                    <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                    <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
            </div>


        <div style = {{textAlign: 'center', marginTop: '25px'}} >
                <span style= {{fontSize: '18px', lineHeight: '41px', fontWeight: '600', letterSpacing: '0.11px', color: '#171725'}} > Student: {formData.studentName} S/D/O {formData.fatherName} </span>
        </div>

        <div style = {{textAlign: 'center', marginBottom: '5px'}} >
                <img src={formData.photo} style={{maxWidth:'100px', maxHeight: '100px'}} ></img>
        </div>

        <div style = {{textAlign: 'center', marginBottom: '25px'}} >
                <span style= {{fontSize: '18px', lineHeight: '41px', fontWeight: '600', letterSpacing: '0.11px', color: '#171725'}} > Category: {formData.category} </span>
        </div>

        <div className="d-flex justify-content-between gap-4 pb-3 pt-4">
          <button className="btn btn-primary w-50" type="button" onClick={startNewApplication} > Apply New Application </button>
          <button className="btn btn-success w-50" type="button" onClick={goToApplications}> View Submitted Applications </button>
          <button className="btn btn-secondary w-50" type="button" onClick={goToDashboard}> Show Dashboard </button>                    
        </div>

        </div>
    </div>

)    

};

export default Success;